import { useMutation } from '@tanstack/react-query';
import Toast from '@trinity/chat-components/components/Toast/index.js';
import { WorkspaceObjectType } from '@/enums/workspace';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';

type MoveFolderParams = {
  parentObjectId: number;
} & IWorkspaceId
  & IWorkspaceObjectId;

export const useMoveObjectMutation = (objectType: WorkspaceObjectType) => {

  const apiClient = useChatApiClient();

  return useMutation({
    mutationFn: (params: MoveFolderParams) => {
      return apiClient.workspacesObject.moveObject({
        objectId: params.objectId,
        parentObjectId: params.parentObjectId,
        workspaceId: params.workspaceId,
      });
    },
    onSuccess: (data) => {
      const typeMap: Record<WorkspaceObjectType, string> = {
        [WorkspaceObjectType.File]: 'File',
        [WorkspaceObjectType.Folder]: 'Folder',
        [WorkspaceObjectType.ProjectParent]: 'Project',
        [WorkspaceObjectType.CallTranscript]: 'Transcript',
        [WorkspaceObjectType.Workspace]: 'Workspace',
        [WorkspaceObjectType.Brand]: 'Brand',
      };
      Toast.alert({
        title: `${typeMap[objectType]} Moved`,
      });
      return data;
    },
    onError: () => {
      Toast.error({
        title: 'Error',
        body: `We're sorry, there was an issue with your request`,
      });
    },
  });

};